var map = {
	"./mao_casa.jpg": 2809,
	"./postaurora.png": 8804,
	"./postcristian.jpg": 3180,
	"./postdonatan.jpg": 8091,
	"./postlg.png": 8944,
	"./postproa.jpg": 920,
	"./postwagner.png": 2415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2932;